<template>
    <div
        class="p-5 bg-premium-dark w-100 h-100 br-8 d-flex align-items-center justify-content-start text-white error-view-z-index"
        :class="background"
    >
        <div class="vue-uploadbox-error-text-container">
            <div class="font-size-150 font-weight-bold">
                <slot name="before-title"></slot>
                <span v-html="title"></span>
                <slot name="after-title"></slot>
            </div>

            <div class="d-flex flex-column flex-wrap">
                <slot name="before-description"></slot>
                <ul class="description-list">
                    <li v-for="text in description" v-html="text"></li>
                </ul>
                <slot name="after-description"></slot>
            </div>

            <div v-if="showTryPremiumButton" class="d-flex flex-wrap ml-n4 mb-n2 gap-10">
                <ButtonWithLoadingState
                    data-limit-error-box-btn-get-premium
                    :is-state-loading="isStateLoading"
                    :text="buttonText"
                    icon="m-l-5 fa fa-arrow-right"
                    :show-icon-after-text="true"
                    class="btn btn-lg btn-warning font-weight-bold ml-4 mb-2 try-premium-button"
                    :class="premiumButtonClass"
                    @click.stop.prevent="$emit('generic-action', $event)"
                    ref="buttonPremium"
                ></ButtonWithLoadingState>

                <ButtonWithLoadingState
                    v-if="showSignUpButton"
                    data-limit-error-box-btn-sign-up
                    :is-state-loading="isStateLoading"
                    text="Sign Up"
                    icon="m-l-5 fa fa-arrow-right"
                    :show-icon-after-text="true"
                    class="btn submit-btn font-weight-bold ml-4 mb-2 sign-up-button"
                    :class="premiumButtonClass"
                    @click.stop.prevent="$emit('sign-up', $event)"
                ></ButtonWithLoadingState>

                <ButtonWithLoadingState
                    v-if="showReferralButton"
                    data-limit-error-box-btn-referral
                    :is-state-loading="isStateLoading"
                    text="Refer a friend"
                    icon="m-l-5 fa fa-arrow-right"
                    :show-icon-after-text="true"
                    class="btn submit-btn font-weight-bold ml-4 mb-2 sign-up-button"
                    :class="premiumButtonClass"
                    @click.stop.prevent="$emit('refer-a-friend', $event)"
                ></ButtonWithLoadingState>

                <ButtonWithLoadingState
                    v-if="canDismiss && showStartButton"
                    data-limit-error-box-btn-start-task
                    :is-state-loading="isStateLoading"
                    :text="translate('Start')"
                    icon="m-l-5 fa fa-arrow-right"
                    :show-icon-after-text="true"
                    class="btn btn-lg font-weight-bold ml-0 mb-2 submit-btn text-uppercase try-premium-button"
                    @click.stop.prevent="$emit('start-task', $event)"
                    ref="buttonStartTask"
                ></ButtonWithLoadingState>
            </div>
        </div>

        <Transition name="fade-fast">
            <span
                v-if="canDismiss"
                data-limit-error-box-btn-dismiss
                class="position-absolute cursor-pointer d-block font-size-300 top-0 right-0 pt-3 pr-3 line-height-1ch"
                :class="{ 'opacity-65': isStateLoading }"
                @click.stop.prevent="$emit('dismiss', $event)"
                >&times;</span
            >
        </Transition>
    </div>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import ButtonWithLoadingState from '../../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';
import { projectHelper } from '../../../../misc/project-helper';

export default {
    name: 'ErrorGenericView',
    components: { ButtonWithLoadingState },
    inject: ['background'],
    mixins: [TransFilter],
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: Array,
            required: true,
        },
        buttonText: {
            type: String,
            required: true,
        },
        backButtonText: {
            type: String,
            required: true,
        },
        canDismiss: {
            type: Boolean,
            default: true,
        },
        isStateLoading: {
            type: Boolean,
            default: false,
        },
        showTryPremiumButton: {
            type: Boolean,
            default: true,
        },
        showSignUpButton: {
            type: Boolean,
            default: false,
        },
        showStartButton: {
            type: Boolean,
            default: true,
        },
        showReferralButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            emitValue: '',
        };
    },
    mounted() {
        // setTimeout(() => {
        //     if (!this.showTryPremiumButton) {
        //         return;
        //     }
        //
        //     this.$refs.buttonPremium.$el.classList.add('premium-pulse');
        // }, 5000);
    },
    methods: {},
    computed: {
        premiumButtonClass() {
            const pdf2goOperationsThatNeedDarkBorder = [
                'edit system thumbnail',
                'merge system thumbnail',
                'split system thumbnail',
                'rearrange system thumbnail',
                'rotate system thumbnail',
                'create system thumbnail',
            ];

            let currentOperation = window.pageConfig.operation;
            if (
                projectHelper.isEbook2edit() ||
                (projectHelper.isPdf2go() && pdf2goOperationsThatNeedDarkBorder.includes(currentOperation))
            ) {
                return 'border-dark';
            }

            return '';
        },
    },
};
</script>

<style lang="scss">
.description-list {
    padding-left: 0 !important;

    li:first-child {
        list-style-type: none;
        padding-bottom: 5px;
    }
}
.premium-pulse {
    box-shadow: 0 0 0 1rem rgba(255, 187, 51, 0);
    animation: pulsing-premium 1.5s cubic-bezier(0.66, 0, 0, 1) 2;
}

.error-view-z-index {
    z-index: 10;
    position: relative;
}

@keyframes pulsing-premium {
    from {
        box-shadow: 0 0 0 0 rgba(255, 187, 51, 0.7);
    }
}
</style>
